/* eslint-disable @typescript-eslint/no-explicit-any */
import { BetPickEntryFragment } from '@graphqlTypes/sitecore';
import { DeepReadonly } from './type-utils';
import OddsStore from '@mobx/stores/kolBetpick/kolOddsLastDate';

/** 是否英文 */
export const isEn = typeof window !== 'undefined' && window.location.pathname.includes('en-US');

/** odds 返回的4种类型 */
export const oddsTypes = ['WIN', 'PLA', 'QIN', 'QPL'];

/** 新的BetType 类型
 * - `WIN`: Win-1值
 * - `PLA`: Place-1值
 * - `QIN`: Quinella-马匹组合值
 * - `QPL`: Quinella Place-马匹组合值
 * - `QQP`: QIN & QPL 的马匹组合值
 * - `WP`: WIN & PLA 的马匹组合值
 */
export const IsNewBetType = ['WIN', 'PLA', 'QIN', 'QPL', 'QQP', 'WP'];

/** Win-Place样式不同 */
export const isWinPLA = 'WP';

/** 组合样式不同
 *  - `QIN`: Quinella-马匹组合值
 *  - `QPL`: Quinella Place-马匹组合值
 *  - `QQP`: QIN & QPL 的马匹组合值
 */
export const isCOMBI = ['QIN', 'QPL', 'QQP'];

/** SCR类型处理
 * - `Scratched`
 */
export const SCRStatus = ['Scratched'];
/** (R)类型处理
 * - `Standby`
 * - `SratchedReserved`
 */
export const RStatus = ['Standby', 'SratchedReserved'];
/** 同时SCR和(R)类型处理
 *  - `ScratchedReserved`
 */
export const SCRRStatus = ['ScratchedReserved'];

/** 从RacingData中过滤传入的场次及马匹 */
export const getFilteredRunners = (racesList: any, raceNo: number, runnerNos: string[]) => {
    // 找到对应的场次
    const race = racesList.find((r: any) => r.no === raceNo);

    if (!race) {
        return []; // 如果没有找到该场次，返回空数组
    }

    // 过滤出对应的跑马
    const filteredRunners = race.runners.filter((runner: any) => runnerNos.includes(runner.no));

    return filteredRunners;
};

/** 通过投注类型编号及马匹编号获取
 * - 马匹中英名字 |
 * - 马匹赔率 |
 * - 马匹hot |
 */

/** 组合CMS 查询条件
 * 
 * if （bankerRow有值） {
    bankerRow+selRow
bankerRow+selRow2nd
bankerRow+selRow3rd
bankerRow+selRow4th
} else {
 if 只有有selRow值就输出selRow
 if selRow和selRow2nd有值就输出 selRow+selRow2ndSCR
 if selRow和selRow2nd和selRow3rd有值就输出
 selRow+selRow2ndSCR
 selRow+selRow3rd
 selRow2ndSCR+selRow3rd
 if selRow和selRow2nd和selRow3rd和selRow4th有值就输出
 selRow+selRow2ndSCR
 selRow+selRow3rd
 selRow+selRow4th
 selRow2ndSCR+selRow3rd
 selRow2ndSCR+selRow4th
 selRow3rd+selRow4th
}
转成['08,09', '08,11', '08,10', '09,11', '09,10', '10,11']
 */
export const BetDataProcessor = (CMSBetpick: DeepReadonly<BetPickEntryFragment>) => {
    const { bankerRow, selRow, selRow2nd, selRow3rd, selRow4th } = CMSBetpick;
    // console.log('data============', CMSBetpick);

    if (bankerRow?.value) {
        const values = [bankerRow, selRow, selRow2nd, selRow3rd, selRow4th];
        // console.log('values=======', values);

        // 生成组合
        const result: string[] = values
            .map((item: any) => item.value) // 提取值
            .filter(Boolean) // 过滤掉空值
            .filter((value) => value !== bankerRow.value) // 过滤掉 bankerRow 自身
            .reduce((acc: Set<string>, value: string) => {
                const paddedValue = padWithZero(value);
                const paddedBankerValue = padWithZero(bankerRow.value ?? '');

                // 判断 bankerRow 的值与选择值的大小
                if (parseInt(bankerRow.value ?? '') > parseInt(value)) {
                    acc.add(`${paddedValue},${paddedBankerValue}`); // 小的在前
                } else {
                    acc.add(`${paddedBankerValue},${paddedValue}`); // bankerRow 在前
                }

                return acc;
            }, new Set());

        return [...new Set(result)];
    } else {
        const getResult = (...rows: any) => {
            const validValues = rows
                .map((row: any) => row?.value)
                .filter(Boolean)
                .map(padWithZero);

            // 生成组合
            const result = validValues.flatMap((value: any, index: any) =>
                validValues
                    .slice(index + 1)
                    .map((nextValue: any) => `${padWithZero(value)},${padWithZero(nextValue)}`)
            );

            return [...new Set(result)]; // 去重
        };

        const result = getResult(selRow, selRow2nd, selRow3rd, selRow4th);
        return result;
    }
};

/** 字符串个位数转换
 * 2 => 02
 */
export const padWithZero = (str: string) => (str.length === 1 ? `0${str}` : str);

/** 字符串个位数转换
 * 02 => 2
 */
export const removeLeadingZero = (str: string) => (str.startsWith('0') ? str.slice(1) : str);

/** 数据处理 */
export const CMSData = (
    betpick: DeepReadonly<BetPickEntryFragment>,
    raceRunner: any[],
    oddsList: any[],
    lang: boolean,
    t: any
) => {
    // console.log('betpick-----', betpick);
    // console.log('raceRunner-----', raceRunner);
    // console.log('oddsList-----', oddsList);
    const {
        betPickType,
        bankerRow,
        selRow,
        selRow2nd,
        selRow3rd,
        selRow4th,
        bankerRowIcon,
        bankerRowTips,
        selRowIcon,
        selRowTips,
        selRow2ndIcon,
        selRow2ndTips,
        selRow3rdIcon,
        selRow3rdTips,
        selRow4thIcon,
        selRow4thTips,
    } = betpick;

    /** 白板数据封装 */
    const getWhiteV = (data: string, i: any, isSCR: boolean) => {
        // const isSCR = SCRStatus.includes(i.status);
        const isR = RStatus.includes(i.status);
        const isSCRR = SCRRStatus.includes(i.status);
        const name = `${i.no}. ${isR || isSCRR ? t('betpick.r') : ''}${
            lang ? i.name_en : i.name_ch
        }${isSCR || isSCRR ? ` (${t('betpick.scratched')})` : ''}`;

        if (data === bankerRow?.value) {
            return {
                whiteName: name,
                whiteText: bankerRowTips?.rendered,
                whiteIcon: bankerRowIcon?.src,
            };
        } else if (data === selRow?.value) {
            return {
                whiteName: name,
                whiteText: selRowTips?.rendered,
                whiteIcon: selRowIcon?.src,
            };
        } else if (data === selRow2nd?.value) {
            return {
                whiteName: name,
                whiteText: selRow2ndTips?.rendered,
                whiteIcon: selRow2ndIcon?.src,
            };
        } else if (data === selRow3rd?.value) {
            return {
                whiteName: name,
                whiteText: selRow3rdTips?.rendered,
                whiteIcon: selRow3rdIcon?.src,
            };
        } else if (data === selRow4th?.value) {
            return {
                whiteName: name,
                whiteText: selRow4thTips?.rendered,
                whiteIcon: selRow4thIcon?.src,
            };
        }
    };
    const betPickTypeName = betPickType?.targetItem?.name ?? '';

    const dataList = [
        bankerRow?.value,
        selRow?.value,
        selRow2nd?.value,
        selRow3rd?.value,
        selRow4th?.value,
    ].filter(Boolean);

    if (isCOMBI.includes(betPickTypeName)) {
        const proceDataList = BetDataProcessor(betpick); // 组合查询数据

        // 创建结果对象
        const result: any = {
            horseList: [],
            tableList: [],
        };

        // 生成 horseList
        dataList.forEach((data) => {
            const runner = raceRunner.find((r) => r.no === data);
            if (runner) {
                const qinOddsValue = oddsList
                    .find((odds) => odds.oddsType === 'QIN')
                    ?.oddsNodes.find((node: any) => node.combString === data)?.oddsValue;
                const qplOddsValue = oddsList
                    .find((odds) => odds.oddsType === 'QPL')
                    ?.oddsNodes.find((node: any) => node.combString === data)?.oddsValue;

                const qinOddsSCR = qinOddsValue ? qinOddsValue === 'SCR' : false;
                const qplOddsSCR = qplOddsValue ? qplOddsValue === 'SCR' : false;

                const isSCR = SCRStatus.includes(runner.status) || qinOddsSCR || qplOddsSCR;

                result.horseList.push({
                    no: runner.no,
                    isBankerROw: !!bankerRow?.value,
                    status: runner.status,
                    name_ch: runner.name_ch,
                    name_en: runner.name_en,
                    ...getWhiteV(data || '', runner, isSCR),
                });
            }
        });

        // console.log('proceDataList=======', proceDataList);
        // 生成 tableList
        if (betPickTypeName === 'QQP') {
            proceDataList.forEach((combString: any) => {
                // 处理马匹号码
                const matchNosArray = combString
                    .split(',')
                    .map((no: string) => no.replace(/^0/, ''));

                // console.log('matchNosArray=====', matchNosArray);

                const findQINBetPick = oddsList.find((odds) => odds.oddsType === 'QIN');
                const findQPLBetPick = oddsList.find((odds) => odds.oddsType === 'QPL');
                // 获取 QIN 和 QPL 的赔率信息
                const qinOdds = oddsList
                    .find((odds) => odds.oddsType === 'QIN')
                    ?.oddsNodes.find((node: any) => node.combString === combString);
                const qplOdds = oddsList
                    .find((odds) => odds.oddsType === 'QPL')
                    ?.oddsNodes.find((node: any) => node.combString === combString);

                // 获取最后更新时间
                const QINOddsLastDate =
                    findQINBetPick?.lastUpdateTime && findQINBetPick?.lastUpdateTime !== 'null'
                        ? findQINBetPick?.lastUpdateTime
                        : '';
                const QPLOddsLastDate =
                    findQPLBetPick?.lastUpdateTime && findQPLBetPick?.lastUpdateTime !== 'null'
                        ? findQPLBetPick?.lastUpdateTime
                        : '';

                // 去重并添加最后更新时间
                const lastDateList = Array.from(new Set([QINOddsLastDate, QPLOddsLastDate]));
                OddsStore.addLastUpdateDate(lastDateList);

                if (findQINBetPick && findQPLBetPick) {
                    const isSCR =
                        result.horseList.length > 0 &&
                        matchNosArray.some((no: any) =>
                            result.horseList.some(
                                (item: any) => item.no === no && SCRStatus.includes(item.status)
                            )
                        );

                    const isSCRR =
                        result.horseList.length > 0 &&
                        matchNosArray.some((no: any) =>
                            result.horseList.some(
                                (item: any) => item.no === no && SCRRStatus.includes(item.status)
                            )
                        );

                    // 检查马匹状态
                    const horsesWithStatus = matchNosArray.map((no: any) => {
                        const horse = result.horseList.find((item: any) => item.no === no);
                        return {
                            no,
                            isSCR: horse && SCRStatus.includes(horse.status),
                            isR: horse && RStatus.includes(horse.status),
                            isSCRR: horse && SCRRStatus.includes(horse.status),
                        };
                    });

                    const combinations: any = [];
                    const seenCombos = new Set();

                    // 生成组合
                    horsesWithStatus.forEach((horse1: any, index1: any) => {
                        horsesWithStatus.forEach((horse2: any, index2: any) => {
                            // 确保不同马匹，并且避免重复（如 1+2 和 2+1）
                            if (index1 < index2) {
                                // 根据状态处理第一个马匹的名称
                                const horse1Name = horse1.isSCR
                                    ? `${horse1.no} ${isEn ? '(SCR)' : '(退出)'}`
                                    : horse1.isR
                                    ? `${isEn ? '(R)' : '(備)'}${horse1.no}`
                                    : horse1.isSCRR
                                    ? `${isEn ? '(R)' : '(備)'}${horse1.no} ${
                                          isEn ? '(SCR)' : '(退出)'
                                      }`
                                    : horse1.no;

                                // 根据状态处理第二个马匹的名称
                                const horse2Name = horse2.isSCR
                                    ? `${horse2.no} ${isEn ? '(SCR)' : '(退出)'}`
                                    : horse2.isR
                                    ? `${isEn ? '(R)' : '(備)'}${horse2.no}`
                                    : horse2.isSCRR
                                    ? `${isEn ? '(R)' : '(備)'}${horse2.no} ${
                                          isEn ? '(SCR)' : '(退出)'
                                      }`
                                    : horse2.no;

                                // 创建组合字符串
                                const comb = `${horse1Name} + ${horse2Name}`;

                                // 如果这个组合之前没有出现过，则添加
                                if (!seenCombos.has(comb)) {
                                    seenCombos.add(comb);
                                    combinations.push(comb);
                                }
                            }
                        });
                    });

                    // 添加组合到结果中
                    combinations.forEach((comb: any) => {
                        result.tableList.push({
                            combString: comb,
                            horsename: comb,
                            QINHotFavourite: qinOdds?.hotFavourite || false,
                            QINOddsValue:
                                isSCR || isSCRR
                                    ? isEn
                                        ? 'SCR'
                                        : '退出'
                                    : qinOdds
                                    ? qinOdds.oddsValue
                                    : '---',
                            QINOddsDropValue: qinOdds ? qinOdds.oddsDropValue : 0,
                            QPLHotFavourite: qplOdds?.hotFavourite || false,
                            QPLOddsValue:
                                isSCR || isSCRR
                                    ? isEn
                                        ? 'SCR'
                                        : '退出'
                                    : qplOdds
                                    ? qplOdds.oddsValue
                                    : '---',
                            QPLOddsDropValue: qplOdds ? qplOdds.oddsDropValue : 0,
                        });
                    });
                } else {
                    result.tableList = [];
                }
            });
        } else if (['QIN', 'QPL'].includes(betPickTypeName)) {
            proceDataList.forEach((combString: any) => {
                const matchNosArray = combString.split(',').map((no: any) => no.replace(/^0/, ''));

                const findBetpick = oddsList.find((odds) => odds.oddsType === betPickTypeName);

                const odds = oddsList
                    .find((odds) => odds.oddsType === betPickTypeName)
                    ?.oddsNodes.find((node: any) => node.combString === combString);

                // console.log('ODDS-----', odds);
                // last update 处理
                const winOddsLastDate =
                    findBetpick?.lastUpdateTime && findBetpick?.lastUpdateTime !== 'null'
                        ? findBetpick?.lastUpdateTime
                        : '';
                OddsStore.addLastUpdateDate(winOddsLastDate);

                if (findBetpick) {
                    const isSCR =
                        result.horseList.length > 0 &&
                        matchNosArray.some((no: any) =>
                            result.horseList.some(
                                (item: any) => item.no === no && SCRStatus.includes(item.status)
                            )
                        );

                    const isSCRR =
                        result.horseList.length > 0 &&
                        matchNosArray.some((no: any) =>
                            result.horseList.some(
                                (item: any) => item.no === no && SCRRStatus.includes(item.status)
                            )
                        );

                    const horsesWithStatus = matchNosArray.map((no: any) => {
                        const horse = result.horseList.find((item: any) => item.no === no);
                        return {
                            no,
                            isSCR: horse && SCRStatus.includes(horse.status),
                            isR: horse && RStatus.includes(horse.status),
                            isSCRR: horse && SCRRStatus.includes(horse.status),
                        };
                    });

                    const combinations: any = [];

                    const seenCombos = new Set();

                    // 生成组合
                    horsesWithStatus.forEach((horse1: any, index1: any) => {
                        horsesWithStatus.forEach((horse2: any, index2: any) => {
                            // 确保不同马匹，并且避免重复（如 1+2 和 2+1）
                            if (index1 < index2) {
                                // 根据状态处理第一个马匹的名称
                                const horse1Name = horse1.isSCR
                                    ? `${horse1.no} ${isEn ? '(SCR)' : '(退出)'}`
                                    : horse1.isR
                                    ? `${isEn ? '(R)' : '(備)'}${horse1.no}`
                                    : horse1.isSCRR
                                    ? `${isEn ? '(R)' : '(備)'}${horse1.no} ${
                                          isEn ? '(SCR)' : '(退出)'
                                      }`
                                    : horse1.no;

                                // 根据状态处理第二个马匹的名称
                                const horse2Name = horse2.isSCR
                                    ? `${horse2.no} ${isEn ? '(SCR)' : '(退出)'}`
                                    : horse2.isR
                                    ? `${isEn ? '(R)' : '(備)'}${horse2.no}`
                                    : horse2.isSCRR
                                    ? `${isEn ? '(R)' : '(備)'}${horse2.no} ${
                                          isEn ? '(SCR)' : '(退出)'
                                      }`
                                    : horse2.no;

                                // 创建组合字符串
                                const comb = `${horse1Name} + ${horse2Name}`;

                                // 如果这个组合之前没有出现过，则添加
                                if (!seenCombos.has(comb)) {
                                    seenCombos.add(comb);
                                    combinations.push(comb);
                                }
                            }
                        });
                    });

                    // 添加组合到结果中
                    combinations.forEach((comb: any) => {
                        result.tableList.push({
                            combString: comb,
                            horsename: comb,
                            [`${betPickTypeName}HotFavourite`]: odds?.hotFavourite
                                ? odds.hotFavourite
                                : false, // 根据需要添加
                            [`${betPickTypeName}OddsValue`]:
                                isSCR || isSCRR
                                    ? isEn
                                        ? 'SCR'
                                        : '退出'
                                    : odds?.oddsValue || '---', // 根据需要添加赔率
                            [`${betPickTypeName}OddsDropValue`]: odds?.oddsDropValue
                                ? odds.oddsDropValue
                                : null, // 根据需要添加
                        });
                    });
                } else {
                    result.tableList = [];
                }
            });
        }
        return result;
    } else if (betPickTypeName === isWinPLA) {
        const result = dataList
            .map((dataNo) => {
                // 找到对应的 raceRunner
                const runner = raceRunner.find((r) => r.no === dataNo);
                if (runner) {
                    const winOddsListObj = oddsList.find((i) => i.oddsType === 'WIN');
                    const PLAOddsListObj = oddsList.find((i) => i.oddsType === 'PLA');

                    // last update 处理
                    const winOddsLastDate =
                        winOddsListObj?.lastUpdateTime && winOddsListObj?.lastUpdateTime !== 'null'
                            ? winOddsListObj?.lastUpdateTime
                            : '';
                    const PLAOddsLastDate =
                        PLAOddsListObj?.lastUpdateTime && PLAOddsListObj?.lastUpdateTime !== 'null'
                            ? PLAOddsListObj?.lastUpdateTime
                            : '';
                    const lastDateList = Array.from(new Set([winOddsLastDate, PLAOddsLastDate]));

                    OddsStore.addLastUpdateDate(lastDateList);

                    // 找到对应的 oddsNode
                    const winOddsNode = winOddsListObj?.oddsNodes?.find((odds: any) => {
                        const newDataNo = padWithZero(dataNo ?? '');
                        if (odds.combString === newDataNo) {
                            return odds;
                        }
                    });
                    const PLAOddsNode = PLAOddsListObj?.oddsNodes?.find((odds: any) => {
                        const newDataNo = padWithZero(dataNo ?? '');
                        if (odds.combString === newDataNo) {
                            return odds;
                        }
                    });

                    const winOddsSCR = winOddsNode ? winOddsNode?.oddsValue === 'SCR' : false;
                    const PLAOddsSCR = PLAOddsNode ? PLAOddsNode?.oddsValue === 'SCR' : false;

                    const isSCR = SCRStatus.includes(runner.status) || winOddsSCR || PLAOddsSCR;

                    return {
                        no: runner.no,
                        status: runner.status,
                        name_ch: runner.name_ch,
                        name_en: runner.name_en,
                        winOddsValue: winOddsNode ? winOddsNode.oddsValue : '---',
                        winHotFavourite: winOddsNode ? winOddsNode.hotFavourite : null,
                        winOddsDropValue: winOddsNode ? winOddsNode.oddsDropValue : 0,
                        PLAOddsValue: PLAOddsNode ? PLAOddsNode.oddsValue : '---',
                        PLAHotFavourite: PLAOddsNode ? PLAOddsNode.hotFavourite : null,
                        PLAOddsDropValue: PLAOddsNode ? PLAOddsNode.oddsDropValue : 0,
                        ...getWhiteV(dataNo || '', runner, isSCR),
                    };
                }
                return null; // 如果没有找到对应的 raceRunner，返回 null
            })
            .filter((item) => item !== null);
        return result;
    } else if (betPickTypeName === 'PLA') {
        const result = dataList
            .map((dataNo) => {
                // 找到对应的 raceRunner
                const runner = raceRunner.find((r) => r.no === dataNo);
                if (runner) {
                    const oddsListObj = oddsList.find((i) => i.oddsType === 'PLA');
                    // last update 处理
                    const oddsLastDate =
                        oddsListObj?.lastUpdateTime && oddsListObj?.lastUpdateTime !== 'null'
                            ? oddsListObj?.lastUpdateTime
                            : '';
                    OddsStore.addLastUpdateDate(oddsLastDate);

                    // 找到对应的 oddsNode
                    const oddsNode = oddsListObj?.oddsNodes?.find((odds: any) => {
                        const newDataNo = padWithZero(dataNo ?? '');
                        if (odds.combString === newDataNo) {
                            return odds;
                        }
                    });

                    const oddsSCR = oddsNode ? oddsNode?.oddsValue === 'SCR' : false;

                    const isSCR = SCRStatus.includes(runner.status) || oddsSCR;

                    return {
                        no: runner.no,
                        status: runner.status,
                        name_ch: runner.name_ch,
                        name_en: runner.name_en,
                        oddsValue: oddsNode ? oddsNode.oddsValue : '---',
                        hotFavourite: oddsNode ? oddsNode.hotFavourite : null,
                        oddsDropValue: oddsNode ? oddsNode.oddsDropValue : 0,
                        ...getWhiteV(dataNo || '', runner, isSCR),
                    };
                }
                return null;
            })
            .filter((item) => item !== null);
        return result;
    } else {
        const result = dataList
            .map((dataNo) => {
                // 找到对应的 raceRunner
                const runner = raceRunner.find((r) => r.no === dataNo);
                if (runner) {
                    const oddsListObj = oddsList.find((i) => i.oddsType === 'WIN');
                    // last update 处理
                    const oddsLastDate =
                        oddsListObj?.lastUpdateTime && oddsListObj?.lastUpdateTime !== 'null'
                            ? oddsListObj?.lastUpdateTime
                            : '';
                    OddsStore.addLastUpdateDate(oddsLastDate);

                    // 找到对应的 oddsNode
                    const oddsNode = oddsListObj?.oddsNodes?.find((odds: any) => {
                        const newDataNo = padWithZero(dataNo ?? '');
                        if (odds.combString === newDataNo) {
                            return odds;
                        }
                    });

                    const oddsSCR = oddsNode ? oddsNode?.oddsValue === 'SCR' : false;

                    const isSCR = SCRStatus.includes(runner.status) || oddsSCR;

                    return {
                        no: runner.no,
                        status: runner.status,
                        name_ch: runner.name_ch,
                        name_en: runner.name_en,
                        oddsValue: oddsNode ? oddsNode?.oddsValue : '---',
                        hotFavourite: oddsNode ? oddsNode?.hotFavourite : null,
                        oddsDropValue: oddsNode ? oddsNode?.oddsDropValue : 0,
                        ...getWhiteV(dataNo || '', runner, isSCR),
                    };
                }
                return null;
            })
            .filter((item) => item !== null);
        return result;
    }
};

/**
 * if hotFavorite == true  Favorite
 * else oddsDropValue >= 50  Odds Drop by 50%
 * else oddsDropValue >= 20  Odds Drop by 20%
 */
export const oddsDropBlock = (hotFavorite: boolean, oddsDropValue: number) => {
    if (hotFavorite) {
        return 'bg-[#FF0000] rounded text-white';
    } else if (oddsDropValue >= 50) {
        return 'bg-[#B64D18] rounded text-white';
    } else if (oddsDropValue >= 20) {
        return 'bg-[#6EBC3F] rounded text-white';
    }
};
